<template lang="html">
    <div class="serverList-container">
        <div class="serverItem" v-for="(server, index) in list" :key="index" @click="onClickItem(server)">
            <div class="server-icon">
                <img :src="server.server_img" v-if="server.server_img" alt="">
                <img src="@/assets/images/common/car.png" v-else alt="">
            </div>
            <div class="server-text">
                <div class="service-name van-multi-ellipsis--l2">{{server.server_name}}</div>
                <div class="server-coupon">
                    <span v-for="(item, index) in server.coupon" :key="index">{{item}}</span>
                </div>
                <div class="server-price">
                    ￥{{server.server_price}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ServerList',
    components: {

    },
    props: {
        list: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    data () {
        return {

        }
    },
    methods: {
        onClickItem (item) {
            this.$emit('onClickItem', item)
        }
    }
}
</script>
<style lang="stylus" scoped>
.serverList-container
    .serverItem
        display flex
        margin 0 20px
        padding 30px
        margin-bottom 20px
        height 200px
        background #fff
        box-sizing border-box
        border-radius 16px
        .server-icon
            width 140px
            height 140px
            display flex
            align-items center
            overflow hidden
            flex-shrink 0
            img
                width 100%
        .server-text
            margin-left 20px
            margin-right 5px
            .service-name
                font-size 24px
                line-height 1.3
                height 55px
                -webkit-box-pack center
            .server-coupon
                margin-top 14px
                display flex
                span
                    border 2px solid #fc2d2d
                    display flex
                    align-items center
                    justify-content center
                    padding 0 10px
                    height 30px
                    border-radius 6px
                    margin-right 10px
                    font-size 20px
                    color #fc2d2d
            .server-price
                font-size 30px
                color #fc2d2d
</style>
